import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonLibService } from '@lib/services';
import { CheckinBaseComponent } from '@common/components';
import { GetFlightsResultStoreService } from '@common/services';
@Component({
  selector: 'asw-checkin-standby-completed-sub-header',
  templateUrl: './checkin-standby-completed-sub-header.component.html',
  styleUrls: ['./checkin-standby-completed-sub-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [GetFlightsResultStoreService],
})
export class CheckinStandbyCompletedSubHeaderComponent extends CheckinBaseComponent {
  constructor(private common: CommonLibService) {
    super(common);
  }

  override reload(): void {}
  override init(): void {}

  override destroy(): void {}
}
